// 登入來源

export const FACEBOOK = 'facebook'
export const M17_LIVE = '17live'
export const LINE = 'line'
export const INSTAGRAM = 'instagram'
export const HANDSUP = 'handsup' // 自有帳號
export const GUEST = 'guest' // 訪客模式
